/*
 * Yurls Shop — bundelbalk.
 *
 * Telt hoeveel boekjes er in de winkelwagen zitten en zet de balk, de
 * bolletjes en de statusregel daarop. Er wordt geteld in totale boekjes, niet
 * in betaalde: de trede "3 boekjes — je betaalt er 2" is bereikt als je er
 * drie hebt.
 *
 * WAT NIET MEETELT: boekjes die sowieso gratis zijn. Die staan voor nul euro in
 * de winkel en horen niet mee te tellen voor een korting op betaald materiaal —
 * anders haal je de trede "3 boekjes" met drie gratis kleurplaten en belooft de
 * balk iets anders dan Shopify bij het afrekenen doet.
 *
 * Een boekje dat gratis wordt door de bundel telt wel mee: dat is een betaald
 * boekje waarvan de prijs is weggestreept. Het verschil zit in original_price —
 * nul bij een echt gratis boekje, hoger dan nul bij een weggestreept exemplaar.
 *
 * De treden staan in even brede vakken, elk in het midden van zijn eigen vak.
 * Bij drie treden liggen de bolletjes dus op 1/6, 3/6 en 5/6 van de breedte.
 * Daartussen loopt de balk evenredig mee, zodat je aan de balk kunt zien
 * hoever je nog van de volgende trede af bent.
 *
 * Het bijwerken hangt aan drie signalen, want er is er niet een die overal
 * werkt:
 *   • pubsub van het thema — hier meldt de koopknop op de productpagina zich.
 *     Dit is een eigen systeem van Dawn, geen gewone gebeurtenis op het
 *     document; luister je daar niet naar, dan blijft de balk op nul staan
 *     nadat je iets in je winkelwagen legt.
 *   • cart:refresh en cart-update op het document, voor onderdelen die het zo
 *     doorgeven
 *   • de regels in de winkelwagen die vervangen worden — het enige teken dat
 *     daar betrouwbaar afgaat bij het wijzigen van een aantal
 *
 * Verwachte opbouw:
 *   <yurls-bundle-rail>
 *     <span data-fill></span>
 *     <li data-at="1" data-wait="…" data-done="…">…</li>
 *     <li data-at="3" data-wait="…" data-done="…">…</li>
 *     <p data-status data-tpl-next="…" data-tpl-done="…" data-tpl-max="…"></p>
 *   </yurls-bundle-rail>
 *
 * De statusregel is er alleen als de sjablonen zijn meegegeven — in de praktijk
 * dus alleen in de winkelwagen. Op de productpagina blijft het bij de vinkjes,
 * want daar staat de balk in een smalle kolom.
 */

if (!customElements.get('yurls-bundle-rail')) {
  customElements.define(
    'yurls-bundle-rail',
    class YurlsBundleRail extends HTMLElement {
      connectedCallback() {
        this.fillEl = this.querySelector('[data-fill]');
        this.statusEl = this.querySelector('[data-status]');
        this.steps = Array.from(this.querySelectorAll('[data-at]'));
        if (!this.steps.length) return;

        this.marks = this.steps.map(function (el) {
          return parseInt(el.dataset.at, 10) || 0;
        });

        this.onCartEvent = () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.load(), 250);
        };

        document.addEventListener('cart:refresh', this.onCartEvent);
        document.addEventListener('cart-update', this.onCartEvent);

        if (
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS === 'object' &&
          PUB_SUB_EVENTS.cartUpdate
        ) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartEvent);
        }

        // In de winkelwagen worden de regels na elke wijziging vervangen.
        var lines = document.getElementById('main-cart-items');
        if (lines && 'MutationObserver' in window) {
          this.watcher = new MutationObserver(this.onCartEvent);
          this.watcher.observe(lines, { childList: true, subtree: true });
        }

        this.load();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.watcher) this.watcher.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        document.removeEventListener('cart:refresh', this.onCartEvent);
        document.removeEventListener('cart-update', this.onCartEvent);
      }

      /*
       * Alleen boekjes die geld kosten. Zie de toelichting bovenaan: een boekje
       * dat door de bundel gratis is geworden houdt een original_price boven
       * nul en telt dus gewoon mee.
       */
      countable(cart) {
        var items = (cart && cart.items) || [];
        var total = 0;

        for (var i = 0; i < items.length; i++) {
          if (items[i].original_price > 0) total += items[i].quantity;
        }

        return total;
      }

      load() {
        fetch('/cart.js')
          .then(function (response) {
            return response.json();
          })
          .then((cart) => {
            this.render(this.countable(cart));
          })
          .catch(function () {});
      }

      /* Middelpunt van trede i, als percentage van de breedte. */
      centre(index) {
        return ((index + 0.5) / this.marks.length) * 100;
      }

      render(count) {
        var marks = this.marks;
        var last = marks.length - 1;
        var percentage;

        if (count <= 0) {
          percentage = 0;
        } else if (count >= marks[last]) {
          // Hoogste trede gehaald: de balk helemaal vol, ook al staat het
          // laatste bolletje niet aan de rand.
          percentage = 100;
        } else if (count <= marks[0]) {
          percentage = (count / marks[0]) * this.centre(0);
        } else {
          var i = 0;
          while (i < last && count >= marks[i + 1]) i++;

          var span = marks[i + 1] - marks[i];
          var part = span > 0 ? (count - marks[i]) / span : 0;
          percentage = this.centre(i) + part * (this.centre(i + 1) - this.centre(i));
        }

        if (this.fillEl) this.fillEl.style.width = percentage + '%';

        this.steps.forEach(function (el, index) {
          el.toggleAttribute('data-reached', count >= marks[index]);
        });

        this.setAttribute('data-count', count);
        this.renderStatus(count);
      }

      /* Zet [aantal], [boekjes], [beloning] en [behaald] in een sjabloon. */
      fill(template, values) {
        var text = template || '';

        Object.keys(values).forEach(function (key) {
          text = text.split('[' + key + ']').join(values[key]);
        });

        return text.trim();
      }

      /*
       * De regel onder de balk. Drie gevallen:
       *
       *   leeg mandje   niets tonen — er valt nog niets te melden
       *   hoogste trede alleen de eindtekst
       *   daartussen    hoeveel er nog bij moeten, en wat dat oplevert
       *
       * Kom je precies op een trede uit die iets oplevert, dan gaat daar de
       * gelukt-tekst voor. Trede 1 heeft bewust geen behaald-tekst: je eerste
       * boekje kopen is geen beloning, dus daar hoort geen "Gelukt" bij.
       */
      renderStatus(count) {
        var el = this.statusEl;
        if (!el) return;

        var marks = this.marks;
        var last = marks.length - 1;

        if (count <= 0) {
          el.textContent = '';
          el.hidden = true;
          return;
        }

        if (count >= marks[last]) {
          el.textContent = this.fill(el.dataset.tplMax, {
            behaald: this.steps[last].dataset.done || ''
          });
          el.hidden = false;
          return;
        }

        var zinnen = [];

        // Precies op een trede beland?
        var raak = marks.indexOf(count);
        if (raak > -1 && this.steps[raak].dataset.done) {
          zinnen.push(
            this.fill(el.dataset.tplDone, { behaald: this.steps[raak].dataset.done })
          );
        }

        // De eerstvolgende trede die nog niet gehaald is.
        var volgende = 0;
        while (volgende <= last && count >= marks[volgende]) volgende++;

        var tekort = marks[volgende] - count;
        zinnen.push(
          this.fill(el.dataset.tplNext, {
            aantal: tekort,
            boekjes: tekort === 1 ? el.dataset.single : el.dataset.plural,
            beloning: this.steps[volgende].dataset.wait || ''
          })
        );

        el.textContent = zinnen.join(' ');
        el.hidden = false;
      }
    }
  );
}
